/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const NDCORClaimRadioData = [
  { name: 'NDC', value: 'ndc' },
  { name: 'Claim ID', value: 'claimId' },
];

export const RegularSuppData = [
  { name: 'Regular', value: 'Regular' },
  { name: 'Supplemental', value: 'Supplemental' },
];

export const SelectedClaimModeDataNu = [
  { name: 'Maintain', value: 'maintain' },
  { name: 'Display', value: 'display' },
];

export const SelectedClaimTab = [
  { label: 'Drug', value: 'drug' },
  { label: 'Claims', value: 'claims' },
];
